import { Box } from '#/components/Box/Box';
import { Icon } from '#/components/Icon/Icon';
import { HeadingSmall } from '#/components/Text/HeadingSmall';
import { VersionedRouterLink } from '#/components/VersionedLink/VersionedRouterLink';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { CmsApiMiniPage } from '#/modules/cms/api/types/CmsApiMiniPage';

type Props = {
  homePage: CmsApiMiniPage;
  publicName: string;
};

export function PostSearchSidebarParentSubsiteHeader({
  homePage,
  publicName,
}: Props) {
  const { i18n } = useI18n();

  return (
    <HeadingSmall fontWeight="semiBold" m={0}>
      <VersionedRouterLink
        to={`/${homePage.url}?pq=`}
        state={{ parentSubsite: null }}
        style={{ textDecoration: 'none' }}
        qaId="back-to-subsite-link"
      >
        <Icon name="chevron-left" size={10} />

        <Box component="span" ml="4px">
          {i18n('Back to %(name)s', { name: publicName })}
        </Box>
      </VersionedRouterLink>
    </HeadingSmall>
  );
}
